import {
  gettask,
  singletask,
  updatetask,
  getsingle,
  audiolabel,
  dataToSleepOcclusion,
  getImgOrAudioWithToken,
  dataToSleepDetection,
  testSleepAPI,
  getLabelMetas,
  rejectLabel,
  getRejectedList,
  correctReject,
} from '@/api/task';

const task = {
  state: {
    label_image: {},
  },
  mutations: {

  },
  actions: {
    Alltask() {
      return new Promise((resolve, reject) => {
        gettask().then((res) => {
          console.log("get response: " + res.error_code)
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    Gettask({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        singletask(data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 指定的meta 資料
    assignmeta({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        getsingle(data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    // 取得下一個task
    Updatetask({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        updatetask(data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    labeltime({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        audiolabel(data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    dataToSleepOcclusion({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        dataToSleepOcclusion(data).then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      });
    },
    getImgOrAudioWithToken({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        getImgOrAudioWithToken(data)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    dataToSleepDetection({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        dataToSleepDetection(data)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    TestSleepAPI({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        testSleepAPI(data.store_type, data.item)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    GetLabelMetas({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        getLabelMetas(data.batch_type, data.user_id, data.batch_date, data.count)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    RejectLabel({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        rejectLabel(data.batch_type, data.name, data.reason, data.batch_date)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    GetRejectedList({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        getRejectedList(data.batch_type, data.batch_date)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
    CorrectReject({
      commit,
    }, data) {
      return new Promise((resolve, reject) => {
        correctReject(data.batch_type, data.data)
          .then((res) => { resolve(res); })
          .catch((error) => { reject(error); });
      });
    },
  },
};

export default task;
